module.exports = __webpack_public_path__ + "img/f1.96e3dcde.webp";